import { render, staticRenderFns } from "./ActivityTimeLineItemDocumentCard.vue?vue&type=template&id=cc22ccc8&"
import script from "./ActivityTimeLineItemDocumentCard.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemDocumentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCardSubtitle,VListItem})
